export const CONTACT = {
  brand: "MN VTC",
  phoneDisplay: "06 99 24 66 07",
  phoneHref: "tel:+33699246607",
  whatsapp: "https://wa.me/33699246607?text=Bonjour%20MN%20VTC%2C%20je%20souhaite%20r%C3%A9server%20un%20trajet.",
  whatsappNumber: "33699246607",
  email: "vtcmn34@outlook.com",
  emailHref: "mailto:vtcmn34@outlook.com",
  zone: "Béziers · Hérault (34) · Occitanie",
  tagline: "Confort, discrétion et élégance",
  hours: "24H/24 · 7J/7",
  googleReviews: "https://www.google.fr/search?sa=X&sca_esv=052c6951bcaaba96&cs=0&hl=fr-FR&kgmid=/g/11ntgsy_b4&q=MN+VTC+34",
};

const A = "https://customer-assets-wrfwihn1.emergentagent.net/job_reserve-course/artifacts";
export const IMAGES = {
  hero: `${A}/p11b4y9v_BC0EDFB2-479F-4487-8548-9F906329D5D6.png`,
  front: `${A}/c9oqjx7c_2D4D8A08-F09C-40AC-BD94-33D604D8E5E1.png`,
  standing: `${A}/xmd9xs2r_7918A51B-3C7E-4D28-9EF7-5CF06D826A65.png`,
  portrait: `${A}/9rq349cu_2CCF9DF7-4468-4B61-BDF5-D2D6B12A82A1.png`,
  seats: `${A}/qox6l362_DC88BE12-D615-454B-8B91-D980657BA8C1.png`,
  interior: `${A}/fb36voyc_76315D7C-C046-42D1-B048-FF1BB9BA22A1.png`,
  road: `${A}/dmic5dbw_F4C7815F-3300-4B54-A29F-1F786CB245CC.png`,
  palm: "https://images.pexels.com/photos/31509786/pexels-photo-31509786.jpeg?auto=compress&cs=tinysrgb&w=1400",
  airport: "https://images.pexels.com/photos/6726195/pexels-photo-6726195.jpeg?auto=compress&cs=tinysrgb&w=1400",
};
